export const projectStatusMap = {
  DRAFT: { label: '未开始', type: 'info' },
  IN_PROGRESS: { label: '进行中', type: '' },
  COMPLETED: { label: '已竣工', type: 'success' }
}

export const stageStatusMap = {
  PENDING: { label: '未开始', type: 'info' },
  DOING: { label: '进行中', type: 'warning' },
  DONE: { label: '已完成', type: 'success' }
}

/** 对齐旧系统项目执行计划·工序状态（由计划/施工日期自动计算） */
export const constructionStatusMap = {
  grey: { label: '未开始', type: 'info' },
  green: { label: '正常', type: 'success' },
  yellow: { label: '延期', type: 'warning' }
}

export const contractStatusMap = {
  DRAFT: { label: '未审核', type: 'info' },
  CONFIRMED: { label: '已审核', type: 'success' }
}

/** 材料申请·审核状态（保存即待审批，无草稿） */
export const materialReqStatusMap = {
  DRAFT: { label: '待审批', type: 'warning' }, // 兼容历史草稿数据
  SUBMITTED: { label: '待审批', type: 'warning' },
  APPROVED: { label: '已审批', type: 'success' },
  REJECTED: { label: '已驳回', type: 'danger' }
}

/** 材料申请·审核状态筛选（待审批合并 DRAFT/SUBMITTED，避免下拉重复） */
export const materialReqStatusFilterOptions = [
  { value: 'SUBMITTED', label: '待审批' },
  { value: 'APPROVED', label: '已审批' },
  { value: 'REJECTED', label: '已驳回' }
]

/** 材料申请·收货状态（App 项目经理收货后变更） */
export const materialReceiveStatusMap = {
  NONE: { label: '未收货', type: 'info' },
  PARTIAL: { label: '部分收货', type: 'warning' },
  FULL: { label: '全收货', type: 'success' }
}

/** 材料退货·审核状态（保存即待审批；DONE 兼容历史完成单；颜色对齐材料申请·审核状态） */
export const materialReturnStatusMap = {
  DRAFT: { label: '待审批', type: 'warning' },
  SUBMITTED: { label: '待审批', type: 'warning' },
  APPROVED: { label: '已审批', type: 'success' },
  REJECTED: { label: '已驳回', type: 'danger' },
  DONE: { label: '已完成', type: 'success' }
}

/** 材料退货·审核状态筛选（无「已完成」；待审批合并 DRAFT/SUBMITTED） */
export const materialReturnStatusFilterOptions = [
  { value: 'SUBMITTED', label: '待审批' },
  { value: 'APPROVED', label: '已审批' },
  { value: 'REJECTED', label: '已驳回' }
]

/** 工资申请·审批状态（保存即待审批，无草稿） */
export const laborReqStatusMap = {
  DRAFT: { label: '待审批', type: 'warning' }, // 兼容历史草稿
  SUBMITTED: { label: '待审批', type: 'warning' },
  APPROVED: { label: '已审批', type: 'success' },
  REJECTED: { label: '已驳回', type: 'danger' }
}

/** 工资申请·审批状态筛选（待审批合并 DRAFT/SUBMITTED） */
export const laborReqStatusFilterOptions = [
  { value: 'SUBMITTED', label: '待审批' },
  { value: 'APPROVED', label: '已审批' },
  { value: 'REJECTED', label: '已驳回' }
]

/** 工资申请·发放状态（单头；颜色对齐材料申请·收货状态） */
export const laborPayStatusMap = {
  NONE: { label: '未发放', type: 'info' },
  PARTIAL: { label: '部分发放', type: 'warning' },
  FULL: { label: '全发放', type: 'success' },
  PAID: { label: '已发放', type: 'success' } // 明细行兼容
}

/** 工资申请·发放状态筛选（仅单头三种） */
export const laborPayStatusFilterOptions = [
  { value: 'NONE', label: '未发放' },
  { value: 'PARTIAL', label: '部分发放' },
  { value: 'FULL', label: '全发放' }
]

/** 工资申请·确认状态（颜色对齐材料申请·收货状态） */
export const laborConfirmStatusMap = {
  NONE: { label: '未确认', type: 'info' },
  PARTIAL: { label: '部分确认', type: 'warning' },
  FULL: { label: '全确认', type: 'success' },
  CONFIRMED: { label: '已确认', type: 'success' } // 明细行兼容
}

/** 工资申请·确认状态筛选（仅单头三种） */
export const laborConfirmStatusFilterOptions = [
  { value: 'NONE', label: '未确认' },
  { value: 'PARTIAL', label: '部分确认' },
  { value: 'FULL', label: '全确认' }
]

export function statusLabel(map, code) {
  return (map[code] && map[code].label) || code || '-'
}

export function statusType(map, code) {
  return (map[code] && map[code].type) || 'info'
}
